module.exports = __webpack_public_path__ + "static/media/logo.22c4883e.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/logo.png
// module id = 51
// module chunks = 0